import { useQuery, useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../../js/api/axios";
import { queryClient } from "../queryClient";

export const fetchCollectionForm = async ({
  collectionId,
  isAddToCollection,
}) => {
  const baseUrl = "/umbraco/api/colourCollections/collectionDetails/";
  const params = new URLSearchParams();
  if (collectionId) params.append("collectionId", collectionId);
  params.append("isAddToCollection", !!isAddToCollection);
  const response = await axiosInstance.get(`${baseUrl}?${params}`);
  return response.data;
};

export const useGetCollectionForm = ({ collectionId, isAddToCollection }) => {
  return useQuery({
    queryKey: ["update-color-collection", collectionId, isAddToCollection],
    queryFn: () => fetchCollectionForm({ collectionId, isAddToCollection }),
  });
};

export const updateColorCollection = async ({ url, body }) => {
  const response = await axiosInstance.post(url, body);
  return response.data;
};

export const useEditColorCollection = () => {
  return useMutation({
    mutationFn: async ({ url, body }) => {
      return await updateColorCollection({ url, body });
    },
    onSuccess: (responseData, { successHandler }) => {
      queryClient.invalidateQueries("add-to-collection").then(() => {
        if (successHandler) {
          successHandler(responseData);
        }
      });
    },
    onError: (data, { errorHandler }) => {
      if (errorHandler) {
        errorHandler(data);
      }
    },
  });
};
